import { useParams, Link } from 'react-router-dom';
import { getComicById } from '@/mocks/comics';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';

const dummyChapterImages = [
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20page%2C%20full%20color%20manga%20panel%2C%20professional%20illustration%2C%20clean%20lineart%2C%20dynamic%20composition%2C%20webtoon%20style%2C%20beautiful%20character%20design%2C%20romance%20scene&width=900&height=1300&seq=ch-reader-p01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20page%2C%20full%20color%20manga%20panel%2C%20professional%20illustration%2C%20conversation%20scene%2C%20webtoon%20style%2C%20beautiful%20character%20design%2C%20emotional%20expression&width=900&height=1300&seq=ch-reader-p02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20page%2C%20full%20color%20manga%20panel%2C%20professional%20illustration%2C%20dramatic%20scene%2C%20webtoon%20style%2C%20action%20pose%2C%20beautiful%20character%20design&width=900&height=1300&seq=ch-reader-p03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20page%2C%20full%20color%20manga%20panel%2C%20professional%20illustration%2C%20intimate%20moment%2C%20webtoon%20style%2C%20soft%20lighting%2C%20beautiful%20character%20design&width=900&height=1300&seq=ch-reader-p04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20page%2C%20full%20color%20manga%20panel%2C%20professional%20illustration%2C%20cliffhanger%20ending%2C%20webtoon%20style%2C%20dramatic%20lighting%2C%20beautiful%20character%20design&width=900&height=1300&seq=ch-reader-p05&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20page%2C%20full%20color%20manga%20panel%2C%20professional%20illustration%2C%20city%20background%2C%20webtoon%20style%2C%20atmospheric%20scene%2C%20beautiful%20character%20design&width=900&height=1300&seq=ch-reader-p06&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20page%2C%20full%20color%20manga%20panel%2C%20professional%20illustration%2C%20emotional%20scene%2C%20webtoon%20style%2C%20warm%20lighting%2C%20beautiful%20character%20design&width=900&height=1300&seq=ch-reader-p07&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20page%2C%20full%20color%20manga%20panel%2C%20professional%20illustration%2C%20group%20conversation%2C%20webtoon%20style%2C%20bright%20lighting%2C%20beautiful%20character%20design&width=900&height=1300&seq=ch-reader-p08&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20page%2C%20full%20color%20manga%20panel%2C%20professional%20illustration%2C%20romantic%20moment%2C%20webtoon%20style%2C%20soft%20focus%2C%20beautiful%20character%20design&width=900&height=1300&seq=ch-reader-p09&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20page%2C%20full%20color%20manga%20panel%2C%20professional%20illustration%2C%20closing%20scene%2C%20webtoon%20style%2C%20golden%20lighting%2C%20beautiful%20character%20design&width=900&height=1300&seq=ch-reader-p10&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20page%2C%20full%20color%20manga%20panel%2C%20professional%20illustration%2C%20tense%20dialogue%2C%20webtoon%20style%2C%20cinematic%20lighting%2C%20beautiful%20character%20design&width=900&height=1300&seq=ch-reader-p11&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20page%2C%20full%20color%20manga%20panel%2C%20professional%20illustration%2C%20cafe%20scene%2C%20webtoon%20style%2C%20cozy%20lighting%2C%20beautiful%20character%20design&width=900&height=1300&seq=ch-reader-p12&orientation=portrait',
];

export default function ChapterReader() {
  const { id, chapterId } = useParams<{ id: string; chapterId: string }>();
  const comic = getComicById(id || '');
  const chapter = comic?.chapters.find((ch) => ch.id === chapterId);
  const chapterIndex = comic?.chapters.findIndex((ch) => ch.id === chapterId) ?? -1;
  const prevChapter = chapterIndex > 0 ? comic?.chapters[chapterIndex - 1] : null;
  const nextChapter = chapterIndex < (comic?.chapters.length ?? 0) - 1 ? comic?.chapters[chapterIndex + 1] : null;

  if (!comic || !chapter) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-heading text-foreground-800 mb-2">章节不存在</h2>
          <Link to="/" className="text-sm text-primary-500 hover:text-primary-600">返回首页</Link>
        </div>
      </div>
    );
  }

  const displayImages = dummyChapterImages.slice(0, Math.min(chapter.imageCount, dummyChapterImages.length));

  return (
    <>
      <SEOHead
        title={`${comic.title} ${chapter.title}_妖精漫画网在线观看`}
        description={`妖精漫画网为您提供${comic.title} ${chapter.title}免费在线观看。下拉式阅读模式，极致阅读体验。`}
        keywords={`${comic.title},${chapter.title},韩国漫画在线观看,妖精漫画网`}
        canonicalUrl={`http://lvtianyuan.com/comic/${comic.id}/chapter/${chapter.id}`}
        ogImage={comic.coverImage}
      />

      <main className="pt-16">
        <div className="max-w-[900px] mx-auto px-4 py-4">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: comic.category, href: `/category/${comic.categorySlug}` },
              { label: comic.title, href: `/comic/${comic.id}` },
              { label: chapter.title },
            ]}
          />

          <h1 className="font-heading text-xl font-bold text-foreground-950 mt-2 mb-1">{comic.title}</h1>
          <p className="text-sm text-foreground-500 mb-6">{chapter.title} · 共{chapter.imageCount}页</p>

          <div className="flex flex-col items-center gap-0">
            {displayImages.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`${comic.title} ${chapter.title} 第${index + 1}页`}
                title={`${comic.title} ${chapter.title} - 妖精漫画网`}
                className="w-full max-w-[800px]"
                loading="lazy"
              />
            ))}
            {chapter.imageCount > displayImages.length && (
              <div className="w-full max-w-[800px] py-8 text-center bg-background-100/50 rounded">
                <p className="text-foreground-400 text-sm">更多页面加载中...</p>
              </div>
            )}
          </div>

          <div className="flex items-center justify-between mt-8 py-4 border-t border-background-200/70">
            {prevChapter ? (
              <Link
                to={`/comic/${comic.id}/chapter/${prevChapter.id}`}
                className="inline-flex items-center gap-1 px-4 py-2 rounded-full border border-background-200/70 text-sm text-foreground-600 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-left-line"></i> {prevChapter.title}
              </Link>
            ) : (
              <div />
            )}
            <Link
              to={`/comic/${comic.id}`}
              className="px-4 py-2 rounded-full text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              返回目录
            </Link>
            {nextChapter ? (
              <Link
                to={`/comic/${comic.id}/chapter/${nextChapter.id}`}
                className="inline-flex items-center gap-1 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                {nextChapter.title} <i className="ri-arrow-right-line"></i>
              </Link>
            ) : (
              <div />
            )}
          </div>
        </div>
      </main>
    </>
  );
}